import React, { Component } from 'react';
import { Link } from 'react-router'
import perfilDefault from '../../assets/perfil_default.png';

export const Section = (props) => {
    return (
        <li className={props.className ? props.className : "hidden-folded padder m-t m-b-sm text-muted text-xs"}>
            <span>{props.name}</span>
        </li>
    )
};

export const MenuOptions = (props) => {
    return (
        <li>
            <Link to={props.to}>
                <span>{props.option}</span>
            </Link>
        </li>
    )
};

export const MenuImage = (props) => {
    const src = props.image ? props.image : perfilDefault;
    return( 
    <li className={'padder m-t m-b-sm'}>
        <img
            src={src}
            alt="Imagem do Estabelecimento"
            width="150" height="150"
        />
    </li>)
}

class SideMenu extends Component {
    render() {
        return (<aside id="aside" className="app-aside hidden-xs bg-dark">
            <div className="aside-wrap">
                <div className="navi-wrap">
                    <nav className="navi clearfix">
                        <ul className="nav">
                            {this.props.children}
                        </ul>
                    </nav>
                </div>
            </div>
        </aside>)
    }
};

export default SideMenu



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.js